const CCRInflowConcentrations = () => {
  const StartDate = new datePicker({
    container: '#start-date',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).setDate('2021-10-01');

  const EndDate = new datePicker({
    container: '#end-date',
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).setDate('2022-09-30');

  const nitrogenChartReq = {
    url: '/sites/all/scripts/view/ccr_nutrient_inflows.php',
    table: 'viewer.results_simple',
    fields: ['*'],
    date_field: 'rdate',
    value_field: 'rvalue_converted',
    units_field: 'unit_name',
    start_date: StartDate.getDate(),
    end_date: EndDate.getDate(),
    parameter1: 29,
    parameter2: 29,
    sort: 'rdate ASC, location_name ASC, parameter ASC',
    drupal_user_switch: false,
    drupal_userid: 1,
  };

  const nitrogenChartOpt = {
    container: '#ccr-nutrients-n-inflows-graph-section',
    chartType: 'multi-dimensional scatter',
    categoryField: 'location_name',
    categoryField2: 'parameter',
    colors: ['#23b578', '#5C6BC0'],
    gridlines: true,
    xAxis: true,
    xAxisFormat: '%m/%y',
    yAxis: true,
    tooltipDateFormat: 'MMM DD, YYYY',
    hollowSymbols: true,
  };

  const phosphorusChartReq = {
    url: '/sites/all/scripts/view/ccr_nutrient_inflows.php',
    table: 'viewer.results_simple',
    fields: ['*'],
    date_field: 'rdate',
    value_field: 'rvalue_converted',
    units_field: 'unit_name',
    start_date: StartDate.getDate(),
    end_date: EndDate.getDate(),
    parameter1: 28,
    parameter2: 47,
    sort: 'rdate ASC, location_name ASC, parameter ASC',
    drupal_user_switch: false,
    drupal_userid: 1,
  };

  const phosphorusChartOpt = {
    container: '#ccr-nutrients-p-inflows-graph-section',
    chartType: 'multi-dimensional scatter',
    categoryField: 'location_name',
    categoryField2: 'parameter',
    colors: ['#23b578', '#2196F3'],
    gridlines: true,
    xAxis: true,
    xAxisFormat: '%m/%y',
    yAxis: true,
    tooltipDateFormat: 'MMM DD, YYYY',
    hollowSymbols: true,
  };

  const tssChartReq = {
    url: '/sites/all/scripts/view/ccr_nutrient_inflows.php',
    table: 'viewer.results_simple',
    fields: ['*'],
    date_field: 'rdate',
    value_field: 'rvalue_converted',
    units_field: 'unit_name',
    start_date: StartDate.getDate(),
    end_date: EndDate.getDate(),
    parameter1: 30,
    parameter2: 30,
    sort: 'rdate ASC, location_name ASC, parameter ASC',
    drupal_user_switch: false,
    drupal_userid: 1,
  };

  const tssChartOpt = {
    container: '#ccr-nutrients-tss-inflows-graph-section',
    chartType: 'multi-dimensional scatter',
    categoryField: 'location_name',
    categoryField2: 'parameter',
    colors: ['#23b578', '#2196F3'],
    gridlines: true,
    xAxis: true,
    xAxisFormat: '%m/%y',
    yAxis: true,
    tooltipDateFormat: 'MMM DD, YYYY',
    hollowSymbols: true,
  };

  /**
   * Function used to update charts when user changes the date filters
   */
  function updateData() {
    nitrogenChartReq.start_date = StartDate.getDate();
    nitrogenChartReq.end_date = EndDate.getDate();

    phosphorusChartReq.start_date = StartDate.getDate();
    phosphorusChartReq.end_date = EndDate.getDate();

    tssChartReq.start_date = StartDate.getDate();
    tssChartReq.end_date = EndDate.getDate();

    const nitrogenChart = new Chart(nitrogenChartReq, nitrogenChartOpt);
    const phosphorusChart = new Chart(phosphorusChartReq, phosphorusChartOpt);
    const tssChart = new Chart(tssChartReq, tssChartOpt);
  }

  const nitrogenChart = new Chart(nitrogenChartReq, nitrogenChartOpt);
  const phosphorusChart = new Chart(phosphorusChartReq, phosphorusChartOpt);
  const tssChart = new Chart(tssChartReq, tssChartOpt);
};
